import React from 'react';

import './layout.scss';

interface IProps {
    children: React.ReactNode;
}

export const Layout: React.FC<IProps> = (props) => {
    const { children } = props;

    return (
        <div className="Page">
            <div className="Main">{children}</div>
        </div>
    );
};
